import { init_editor_values_multiple_choice_survey } from 'src/components/templates/MultipleChoiceSurvey/initValues';
import { init_editor_values_rating_answer_survey } from 'src/components/templates/RatingAnswerSurvey/initValues';
import { init_editor_values_short_answer_survey } from 'src/components/templates/ShortAnswerSurvey/initValues';

export const PLUS_TEMPLATES: any = [
  'MULTIPLE CHOICE SURVEY',
  'SHORT ANSWER SURVEY',
  'RATING ANSWER SURVEY',
  'SELECT OPTION SURVEY',
  'NPS MODAL SURVEY'
];

export const PRO_TEMPLATES = [
  'BASIC FULL ROULETTE',
  'BASIC SCRATCH MODAL',
  'BASIC BOTTOM SHEET',
  'CARD MODAL',
  'FLOATING BOTTOM SHEET',
  'BOTTOM SHEET IMAGE',
  'RADIUS MODAL SLIDE',
  'MODAL SLIDE',
  'SIMPLE MODAL SLIDE',
  'CHOICE OPTION IMAGE',
  'SIMPLE CARD MODAL',
  'TRANSPARENT BOTTOM SHEET',
  'BOTTOM SLIDE UP',
  'CHOICE BUTTON MODAL',
  'SIMPLE ICON MODAL',
  'CAROUSEL SLIDE MODAL',
  'AUTO SQUARE SLIDE',
  'BASIC FULL COUNTDOWN',
  'FULL DUAL IMAGE',
  'SLIDE MODAL ROUND',
  'BOTTOM SHEET SLIDE',
  'BASIC FULL IMAGE',
  'RADIUS FULL COUNTDOWN',
  'SIMPLE MODAL',
  'SLIDE FULL IMAGE',
  'SLIDE MODAL IMAGE',
  'AUTO MODAL SLIDE',
  'COUPON BOTTOM SHEET',
  'IMAGE BOTTOM SHEET',
  'ALARM MODAL'
];
export const STARTER_TEMPLATES = [
  'BOTTOM SHEET IMAGE',
  'BASIC BOTTOM SHEET',
  'RADIUS MODAL SLIDE',
  'CARD MODAL',

  'MODAL SLIDE',
  'FLOATING BOTTOM SHEET',
  'SIMPLE MODAL SLIDE'
];
export const FREE_TEMPLATES = [
  'MODAL SLIDE',
  'FLOATING BOTTOM SHEET',
  'SIMPLE MODAL SLIDE'
];

// 뱃지 관리 용 변수
export const NEW_TEMPLATES: any = [
  'BASIC FULL ROULETTE',
  'BASIC SCRATCH MODAL',
  'BASIC BOTTOM SHEET',
  'CARD MODAL',
  'FLOATING BOTTOM SHEET',
  'CHOICE OPTION IMAGE',
  'SIMPLE CARD MODAL',
  'TRANSPARENT BOTTOM SHEET'
];

export const GAME_TEMPLATES: any = [
  'BASIC FULL ROULETTE',
  'BASIC SCRATCH MODAL'
];

export const TEMPLATES: any = [
  'BASIC FULL IMAGE',
  'BOTTOM SLIDE UP',
  'CHOICE BUTTON MODAL',
  'SIMPLE ICON MODAL',
  'CAROUSEL SLIDE MODAL',
  'AUTO SQUARE SLIDE',

  'BOTTOM SHEET IMAGE',
  'RADIUS MODAL SLIDE',
  'MODAL SLIDE',
  'SIMPLE MODAL SLIDE',
  'FULL DUAL IMAGE',
  'BASIC FULL COUNTDOWN',
  'SLIDE MODAL ROUND',

  'BOTTOM SHEET SLIDE',

  'RADIUS FULL COUNTDOWN',
  'SIMPLE MODAL',
  'SLIDE FULL IMAGE',
  'SLIDE MODAL IMAGE',
  'AUTO MODAL SLIDE',
  'COUPON BOTTOM SHEET',
  'IMAGE BOTTOM SHEET',
  'ALARM MODAL'
];

export const CHANGE_IMAGE: any = {
  'full-countdown': 'basic-full-countdown',
  'basic-full-countdown': 'basic-full-countdown',
  'bottom-sheet-image': 'bottom-sheet-image',
  'modal-pading-slide': 'radius-modal-slide',
  'radius-modal-slide': 'radius-modal-slide',
  'full-dual-image': 'full-dual-image',
  'modal-slick-contents': 'modal-slide',
  'modal-slide': 'modal-slide',
  'full-survey': 'simple-survey',
  'simple-survey': 'simple-survey',
  'modal-slide-image': 'slide-modal-round',
  'slide-modal-round': 'slide-modal-round',
  'modal-top-image': 'simple-modal-slide',
  'simple-modal-slide': 'simple-modal-slide',
  'half-slide-up-imgs': 'bottom-sheet-slide',
  'bottom-sheet-slide': 'bottom-sheet-slide',
  'nps-modal-dial': 'nps-modal-survey',
  'promotion-full-image': 'basic-full-image',
  'basic-full-image': 'basic-full-image',
  'countdown-full-circle': 'radius-full-countdown',
  'radius-full-countdown': 'radius-full-countdown',
  'modal-slider-survey': 'modal-slider-survey',
  'slide-full-image': 'slide-full-image',
  'slide-modal-image': 'slide-modal-image',
  'auto-modal-slide': 'auto-modal-slide',
  'cupon-bottom-sheet': 'coupon-bottom-sheet',
  'coupon-bottom-sheet': 'coupon-bottom-sheet',
  'image-bottom-sheet': 'image-bottom-sheet',
  'list-modal': 'list-modal',
  'alarm-modal': 'alarm-modal',
  'half-slide-up': 'bottom-sheet-slide',
  'single-modal-top': 'simple-modal-slide',
  'half-top-image': 'bottom-sheet-image',
  'modal-paging-slide': 'radius-modal-slide',
  'modal-full-image': 'simple-modal',
  'multiple-choice-survey': 'multiple-choice-survey',
  'simple-modal': 'simple-modal',
  'short-answer-survey': 'short-answer-survey',
  'rating-answer-survey': 'rating-answer-survey',
  // 추가중
  'auto-square-slide': 'auto-square-slide',
  'carousel-slide-modal': 'carousel-slide-modal',
  'simple-icon-modal': 'simple-icon-modal',
  'choice-button-modal': 'choice-button-modal',
  'bottom-slide-up': 'bottom-slide-up',
  'transparent-bottom-sheet': 'transparent-bottom-sheet',
  'simple-card-modal': 'simple-card-modal',
  'floating-bottom-sheet': 'floating-bottom-sheet',
  'card-modal': 'card-modal',
  'basic-bottom-sheet': 'basic-bottom-sheet',
  'choice-option-image': 'choice-option-image',
  'basic-scratch-modal': 'basic-scratch-modal',
  'basic-full-roulette': 'basic-full-roulette'
};

export const CHANGE_TEMPLATE: any = {
  'FULL COUNTDOWN': 'BASIC FULL COUNTDOWN',
  'BASIC FULL COUNTDOWN': 'BASIC FULL COUNTDOWN',
  'BOTTOM SHEET IMAGE': 'BOTTOM SHEET IMAGE',
  'MODAL PADING SLIDE': 'RADIUS MODAL SLIDE',
  'RADIUS MODAL SLIDE': 'RADIUS MODAL SLIDE',
  'FULL DUAL IMAGE': 'FULL DUAL IMAGE',
  'MODAL SLICK CONTENTS': 'MODAL SLIDE',
  'MODAL SLIDE': 'MODAL SLIDE',
  'FULL SURVEY': 'SIMPLE SURVEY',
  'SIMPLE SURVEY': 'SIMPLE SURVEY',
  'MODAL SLIDE IMAGE': 'SLIDE MODAL ROUND',
  'SLIDE MODAL ROUND': 'SLIDE MODAL ROUND',
  'MODAL TOP IMAGE': 'SIMPLE MODAL SLIDE',
  'SIMPLE MODAL SLIDE': 'SIMPLE MODAL SLIDE',
  'HALF SLIDE UP IMGS': 'BOTTOM SHEET SLIDE',
  'BOTTOM SHEET SLIDE': 'BOTTOM SHEET SLIDE',
  'NPS MODAL DIAL': 'NPS MODAL SURVEY',
  'NPS MODAL SURVEY': 'NPS MODAL SURVEY',
  'PROMOTION FULL IMAGE': 'BASIC FULL IMAGE',
  'BASIC FULL IMAGE': 'BASIC FULL IMAGE',
  'COUNTDOWN FULL CIRCLE': 'RADIUS FULL COUNTDOWN',
  'RADIUS FULL COUNTDOWN': 'RADIUS FULL COUNTDOWN',
  'MODAL SLIDER SURVEY': 'MODAL SLIDER SURVEY',
  'SLIDE FULL IMAGE': 'SLIDE FULL IMAGE',
  'SLIDE MODAL IMAGE': 'SLIDE MODAL IMAGE',
  'AUTO MODAL SLIDE': 'AUTO MODAL SLIDE',
  'COPON BOTTOM SHEET': 'COUPON BOTTOM SHEET',
  'COUPON BOTTOM SHEET': 'COUPON BOTTOM SHEET',
  'IMAGE BOTTOM SHEET': 'IMAGE BOTTOM SHEET',
  // 'LIST MODAL': 'LIST MODAL',
  'ALARM MODAL': 'ALARM MODAL',
  'HALF SLIDE UP': 'BOTTOM SHEET SLIDE',
  'SINGLE MODAL TOP': 'SIMPLE MODAL SLIDE',
  'HALF TOP IMAGE': 'BOTTOM SHEET IMAGE',
  'MODAL PAGING SLIDE': 'RADIUS MODAL SLIDE',
  'SIMPLE MODAL': 'SIMPLE MODAL',
  'MODAL FULL IMAGE': 'SIMPLE MODAL',
  'MULTIPLE CHOICE SURVEY': 'MULTIPLE CHOICE SURVEY',
  'SHORT ANSWER SURVEY': 'SHORT ANSWER SURVEY',
  'RATING ANSWER SURVEY': 'RATING ANSWER SURVEY',
  // 추가중
  'AUTO SQUARE SLIDE': 'AUTO SQUARE SLIDE',
  'CAROUSEL SLIDE MODAL': 'CAROUSEL SLIDE MODAL',
  'SIMPLE ICON MODAL': 'SIMPLE ICON MODAL',
  'CHOICE BUTTON MODAL': 'CHOICE BUTTON MODAL',
  'BOTTOM SLIDE UP': 'BOTTOM SLIDE UP',
  'TRANSPARENT BOTTOM SHEET': 'TRANSPARENT BOTTOM SHEET',
  'SIMPLE CARD MODAL': 'SIMPLE CARD MODAL',
  'FLOATING BOTTOM SHEET': 'FLOATING BOTTOM SHEET',
  'CARD MODAL': 'CARD MODAL',
  'BASIC BOTTOM SHEET': 'BASIC BOTTOM SHEET',
  'CHOICE OPTION IMAGE': 'CHOICE OPTION IMAGE',
  'BASIC SCRATCH MODAL': 'BASIC SCRATCH MODAL',
  'BASIC FULL ROULETTE': 'BASIC FULL ROULETTE'
};

export const TEMPLATES_EDITOR = {
  'MULTIPLE CHOICE SURVEY': init_editor_values_multiple_choice_survey,
  'SHORT ANSWER SURVEY': init_editor_values_short_answer_survey,
  'RATING ANSWER SURVEY': init_editor_values_rating_answer_survey
};

export const TEMPLATES_TRACKING_EDITOR = {
  'BASIC FULL COUNTDOWN': ['background', 'button'],
  'BOTTOM SHEET IMAGE': ['multi_image', 'multi_button', 'multi_sub_button'],
  'RADIUS MODAL SLIDE': ['multi_image', 'multi_button', 'multi_sub_button'],
  'FULL DUAL IMAGE': ['multi_image', 'multi_button', 'button'],
  'MODAL SLIDE': ['multi_image', 'multi_button', 'multi_sub_button'],

  'SLIDE MODAL ROUND': [
    'multi_image',
    'multi_left_button',
    'multi_right_button'
  ],
  'SIMPLE MODAL SLIDE': [
    'multi_image',
    'multi_left_button',
    'multi_right_button'
  ],
  'BOTTOM SHEET SLIDE': [
    'multi_image',
    'multi_left_button',
    'multi_right_button'
  ],
  'BASIC FULL IMAGE': ['background', 'left_button', 'right_button'],
  'RADIUS FULL COUNTDOWN': ['background', 'button', 'sub_button'],
  'SIMPLE MODAL': ['background', 'button', 'sub_button', 'never_show_button'],
  'MULTIPLE CHOICE SURVEY': [
    'multi_action_survey',
    'multi_button',
    'multi_sub_button'
  ],
  'SLIDE FULL IMAGE': ['multi_image', 'multi_button', 'multi_sub_button'],
  'SLIDE MODAL IMAGE': [
    'multi_image',
    'multi_left_button',
    'multi_right_button'
  ],
  'AUTO MODAL SLIDE': [
    'multi_image',
    'multi_button',
    'left_button',
    'right_button'
  ],
  'SHORT ANSWER SURVEY': [
    'multi_action_survey',
    'multi_textarea',
    'multi_left_button',
    'multi_right_button'
  ],
  'COUPON BOTTOM SHEET': ['button', 'sub_button', 'coupon_button'],
  'IMAGE BOTTOM SHEET': ['button', 'sub_button'],
  // 'LIST MODAL': ['button', 'left_button', 'right_button'],
  'BOTTOM SLIDE UP': ['content', 'close_button', 'background'],
  'ALARM MODAL': ['button', 'left_button', 'right_button', 'never_show_button'],

  'AUTO SQUARE SLIDE': [
    'multi_image',
    'multi_left_button',
    'multi_right_button'
  ],

  'CHOICE BUTTON MODAL': [
    'image_left_button',
    'image_right_button',
    'image_button',
    'bottom_left_button',
    'bottom_right_button'
  ],

  'CAROUSEL SLIDE MODAL': [
    'multi_image',
    'multi_button',
    'multi_left_button',
    'multi_right_button'
  ],
  'SIMPLE ICON MODAL': ['button', 'right_button', 'left_button'],
  'TRANSPARENT BOTTOM SHEET': ['button', 'never_show_button'],
  'SIMPLE CARD MODAL': [
    'multi_image',
    'multi_left_button',
    'multi_right_button'
  ],
  'FLOATING BOTTOM SHEET': ['button', 'never_show_button', 'content'],
  'CARD MODAL': ['close_button', 'button'],
  'BASIC BOTTOM SHEET': ['button', 'never_show_button'],
  'CHOICE OPTION IMAGE': [
    'top_image_button',
    'bottom_image_button',
    'top_left_image_button',
    'top_right_image_button',
    'bottom_left_image_button',
    'bottom_right_image_button',
    'close_button'
  ],
  'BASIC SCRATCH MODAL': [
    'button',
    'bottom_left_button',
    'bottom_right_button'
  ],
  'BASIC FULL ROULETTE': ['start_button', 'result_button', 'close_button']
};

export const TEMPLATES_EDITOR_REGARCY = {
  'BASIC FULL COUNTDOWN': {
    text: {
      bgType: ['background'],
      deeplinkType: ['background'],
      textType: ['year_title', 'title', 'sub_title', 'countdown_title'],
      countdownType: ['countdown']
    },
    button: {
      btnType: ['button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['background', 'button']
    }
  },
  'BOTTOM SHEET IMAGE': {
    dimmed: [0, 100],
    multi: [1, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [180],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_button', 'multi_sub_button'],
      radiusType: ['multi_button', 'multi_sub_button'],
      radiusMax: [32, 32]
    },
    tracking: {
      trackingType: ['multi_image', 'multi_button', 'multi_sub_button']
    }
  },
  'RADIUS MODAL SLIDE': {
    multi: [3, 7],
    text: {
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [100],
      textType: ['countdown_title'],
      multiTextType: ['multi_title'],
      multiCountdownType: ['multi_countdown']
    },
    button: {
      multiBtnType: ['multi_button']
    },
    tracking: {
      trackingType: ['multi_image', 'multi_button', 'multi_sub_button']
    }
  },
  'FULL DUAL IMAGE': {
    multi: [1, 2],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [100],
      textType: ['title', 'sub_title'],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      btnType: ['button'],
      multiBtnType: ['multi_button'],
      radiusType: ['button', 'multi_button'],
      radiusMax: [32, 12]
    },
    tracking: {
      trackingType: ['multi_image', 'multi_button', 'button']
    }
  },
  'CAROUSEL SLIDE MODAL': {
    multi: [1, 10],
    dimmed: [0, 100],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['background', 'multi_image'],
      radiusMax: [50, 100],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_button', 'multi_left_button', 'multi_right_button'],
      againType: ['multi_left_button'],
      radiusType: ['multi_button'],
      radiusMax: [24]
    },
    tracking: {
      trackingType: [
        'multi_image',
        'multi_button',
        'multi_left_button',
        'multi_right_button'
      ]
    }
  },

  'MODAL SLIDE': {
    multi: [3, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['background', 'multi_image'],
      radiusMax: [50, 100],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_button'],
      radiusType: ['multi_button'],
      radiusMax: [24]
    },
    tracking: {
      trackingType: ['multi_image', 'multi_button', 'multi_sub_button']
    }
  },
  // 'SIMPLE SURVEY': {
  //   text: {
  //     type: ['title', 'sub_title']
  //   },
  //   button: {
  //     btnType: ['none_survey', 'button'],
  //     multiBtnType: ['multi_survey']
  //   }
  // },

  'AUTO SQUARE SLIDE': {
    dimmed: [0, 100],
    multi: [1, 10],
    text: {
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['background', 'multi_image'],
      radiusMax: [50, 150]
    },
    button: {
      multiBtnType: ['multi_left_button', 'multi_right_button'],
      againType: ['multi_left_button']
    },
    tracking: {
      trackingType: ['multi_image', 'multi_left_button', 'multi_right_button']
    }
  },

  'CHOICE BUTTON MODAL': {
    dimmed: [0, 100],
    text: {
      convert: [true],
      imageType: ['background'],
      deeplinkType: ['image_left_button', 'image_right_button', 'image_button'],
      radiusType: ['background'],
      radiusMax: [50]
    },
    button: {
      convert: [true],
      btnType: [
        'image_left_button',
        'image_right_button',
        'image_button',
        'bottom_left_button',
        'bottom_right_button'
      ],
      againType: ['bottom_left_button']
    },
    tracking: {
      trackingType: [
        'image_left_button',
        'image_right_button',
        'image_button',
        'bottom_left_button',
        'bottom_right_button'
      ]
    }
  },

  'SLIDE MODAL ROUND': {
    multi: [1, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['background', 'multi_image'],
      radiusMax: [50, 150],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_left_button', 'multi_right_button'],
      againType: ['multi_left_button']
    },
    tracking: {
      trackingType: ['multi_image', 'multi_left_button', 'multi_right_button']
    }
  },
  'SIMPLE MODAL SLIDE': {
    multi: [1, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [50],
      multiTextType: ['multi_title', 'multi_sub_title', 'multi_box_title']
    },
    button: {
      multiBtnType: ['multi_left_button', 'multi_right_button'],
      radiusType: ['multi_left_button', 'multi_right_button'],
      radiusMax: [24, 24]
    },
    tracking: {
      trackingType: ['multi_image', 'multi_left_button', 'multi_right_button']
    }
  },
  'BOTTOM SHEET SLIDE': {
    dimmed: [0, 100],
    multi: [1, 7],
    text: {
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [180],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_left_button', 'multi_right_button']
    },
    tracking: {
      trackingType: ['multi_image', 'multi_left_button', 'multi_right_button']
    }
  },
  'BASIC FULL IMAGE': {
    text: {
      switchMediaType: ['image'],
      imageType: ['background'],
      videoType: ['background'],
      deeplinkType: ['background']
    },
    button: {
      btnType: ['left_button', 'right_button'],
      againType: ['left_button']
    },
    tracking: {
      trackingType: ['background', 'left_button', 'right_button']
    }
  },
  'RADIUS FULL COUNTDOWN': {
    text: {
      imageType: ['background'],
      deeplinkType: ['background'],
      textType: ['sub_title', 'title'],
      countdownType: ['countdown']
    },
    button: {
      btnType: ['button', 'sub_button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['button', 'sub_button']
    }
  },
  'SIMPLE MODAL': {
    dimmed: [0, 100],
    text: {
      imageType: ['background'],
      deeplinkType: ['background']
    },
    button: {
      btnType: ['button', 'never_show_button'],
      againType: ['never_show_button'],
      radiusType: ['button', 'never_show_button'],
      radiusMax: [24, 24]
    },
    tracking: {
      trackingType: ['background', 'button', 'sub_button', 'never_show_button']
    }
  },
  'MULTIPLE CHOICE SURVEY': {
    multi: [1, 12],
    text: {
      multiBgType: ['multi_background'],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_action_survey', 'none_survey', 'multi_button'],
      multiAgainType: ['type', 'multi_action_survey']
    },
    tracking: {
      trackingType: ['multi_action_survey', 'multi_button', 'multi_sub_button']
    }
  },
  'SLIDE FULL IMAGE': {
    multi: [3, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [120],
      multiTextType: ['multi_title', 'multi_sub_title']
    },
    button: {
      multiBtnType: ['multi_button'],
      type: ['sub_button'],
      radiusType: ['multi_button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['multi_image', 'multi_button', 'multi_sub_button']
    }
  },
  'SLIDE MODAL IMAGE': {
    multi: [3, 7],
    text: {
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [150],
      multiTextType: ['multi_title']
    },
    button: {
      multiBtnType: ['multi_left_button', 'multi_right_button']
    },
    tracking: {
      trackingType: ['multi_image', 'multi_left_button', 'multi_right_button']
    }
  },
  'AUTO MODAL SLIDE': {
    multi: [3, 7],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['background', 'multi_image'],
      radiusMax: [50, 100],
      textType: ['title', 'sub_title']
    },
    button: {
      multiBtnType: ['multi_button'],
      btnType: ['left_button', 'right_button'],
      radiusType: ['multi_button'],
      radiusMax: [32],
      againType: ['left_button']
    },
    tracking: {
      trackingType: [
        'multi_image',
        'multi_button',
        'left_button',
        'right_button'
      ]
    }
  },
  'COUPON BOTTOM SHEET': {
    dimmed: [0, 100],
    text: {
      bgType: ['background'],
      deeplinkType: ['background'],
      radiusType: ['background'],
      radiusMax: [180],
      textType: ['title', 'coupon_title', 'coupon_sub_title', 'coupon_date']
    },
    button: {
      btnType: ['coupon_button', 'button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['button', 'sub_button', 'coupon_button']
    }
  },
  'IMAGE BOTTOM SHEET': {
    dimmed: [0, 100],
    text: {
      imageType: ['background'],
      deeplinkType: ['background'],
      radiusType: ['background'],
      radiusMax: [180],
      textType: ['title', 'sub_title']
    },
    button: {
      btnType: ['button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['button', 'sub_button']
    }
  },

  'BOTTOM SLIDE UP': {
    darkMode: [true],
    text: {
      bgType: ['background'],
      imageType: ['logo'],
      deeplinkType: ['content'],
      radiusType: ['background', 'logo'],
      radiusMax: [50, 50],
      textType: ['title']
    },

    tracking: {
      trackingType: ['content', 'close_button']
    }
  },
  'ALARM MODAL': {
    text: {
      bgType: ['background'],
      deeplinkType: ['background'],
      radiusType: ['background'],
      radiusMax: [50],
      textType: ['title', 'sub_title']
    },
    button: {
      btnType: ['button', 'never_show_button', 'sub_button'],
      againType: ['never_show_button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['button', 'left_button', 'right_button']
    }
  },
  'SIMPLE ICON MODAL': {
    dimmed: [0, 100],
    text: {
      bgType: ['background'],
      imageType: ['logo'],
      deeplinkType: ['background'],
      radiusType: ['background'],
      radiusMax: [50],
      textType: ['title', 'sub_title']
    },
    button: {
      btnType: ['button', 'never_show_button', 'sub_button'],
      againType: ['never_show_button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['button', 'left_button', 'right_button']
    }
  },
  'TRANSPARENT BOTTOM SHEET': {
    dimmed: [0, 100],
    text: {
      bgType: ['background'],
      imageType: ['logo'],
      deeplinkType: ['background'],
      radiusType: ['logo', 'background'],
      radiusMax: [180, 180],
      textType: ['title', 'sub_title']
    },
    button: {
      btnType: ['button', 'never_show_button'],
      againType: ['never_show_button'],
      radiusType: ['button', 'never_show_button'],
      radiusMax: [32, 32]
    },
    tracking: {
      trackingType: ['button', 'never_show_button']
    }
  },
  'SIMPLE CARD MODAL': {
    dimmed: [0, 100],
    multi: [1, 10],
    text: {
      bgType: ['background'],
      multiImageType: ['multi_image'],
      multiDeeplinkType: ['multi_image'],
      radiusType: ['multi_image'],
      radiusMax: [50]
    },
    button: {
      multiBtnType: ['multi_left_button', 'multi_right_button'],
      againType: ['multi_left_button']
    },
    tracking: {
      trackingType: ['multi_image', 'multi_left_button', 'multi_right_button']
    }
  },
  'FLOATING BOTTOM SHEET': {
    dimmed: [0, 100],
    text: {
      imageType: ['background'],
      deeplinkType: ['background'],
      radiusType: ['background'],
      radiusMax: [180],
      textType: ['title', 'sub_title']
    },
    button: {
      btnType: ['button', 'never_show_button'],
      againType: ['never_show_button']
    },
    tracking: {
      trackingType: ['content', 'button', 'never_show_button']
    }
  },
  'CARD MODAL': {
    dimmed: [0, 100],
    text: {
      bgType: ['background'],
      deeplinkType: ['background'],
      radiusType: ['background'],
      radiusMax: [50],
      textType: ['title', 'sub_title']
    },
    button: {
      btnType: ['close_button', 'button'],
      againType: ['close_button'],
      radiusType: ['close_button', 'button'],
      radiusMax: [32, 32]
    },
    tracking: {
      trackingType: ['close_button', 'button']
    }
  },
  'BASIC BOTTOM SHEET': {
    dimmed: [0, 100],
    text: {
      bgType: ['background'],
      deeplinkType: ['background'],
      radiusType: ['background'],
      radiusMax: [180],
      textType: ['title', 'sub_title']
    },
    button: {
      btnType: ['button', 'never_show_button'],
      againType: ['never_show_button'],
      radiusType: ['button', 'never_show_button'],
      radiusMax: [32, 32]
    },
    tracking: {
      trackingType: ['button', 'never_show_button']
    }
  },
  'CHOICE OPTION IMAGE': {
    text: {
      switchImageType: [true],
      bgType: ['background'],
      imageType: [
        'top_image',
        'bottom_image',
        'top_left_image',
        'top_right_image',
        'bottom_left_image',
        'bottom_right_image'
      ],
      deeplinkType: [
        'top_image',
        'bottom_image',
        'top_left_image',
        'top_right_image',
        'bottom_left_image',
        'bottom_right_image'
      ],
      radiusType: [
        'top_image',
        'bottom_image',
        'top_left_image',
        'top_right_image',
        'bottom_left_image',
        'bottom_right_image'
      ],
      radiusMax: [50, 50, 50, 50, 50, 50],
      textType: ['title', 'sub_title']
    },
    button: {
      switchImageType: [true],
      btnType: [
        'top_image_button',
        'bottom_image_button',
        'top_left_image_button',
        'top_right_image_button',
        'bottom_left_image_button',
        'bottom_right_image_button',
        'close_button'
      ],
      againType: ['close_button'],
      radiusType: ['close_button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: [
        'top_image_button',
        'bottom_image_button',
        'top_left_image_button',
        'top_right_image_button',
        'bottom_left_image_button',
        'bottom_right_image_button',
        'close_button'
      ]
    }
  },
  'BASIC SCRATCH MODAL': {
    dimmed: [0, 100],
    text: {
      bgType: ['background'],
      imageType: ['image'],
      deeplinkType: ['background'],
      radiusType: ['background', 'image'],
      radiusMax: [50, 50],
      textType: ['title', 'sub_title']
    },
    button: {
      btnType: ['button', 'bottom_left_button', 'bottom_right_button'],
      againType: ['bottom_left_button'],
      radiusType: ['button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: ['button', 'bottom_left_button', 'bottom_right_button']
    }
  },
  'BASIC FULL ROULETTE': {
    dimmed: [0, 100],
    text: {
      bgType: ['roulette_items', 'result_modal_bg'],
      radiusType: ['result_image', 'result_modal_bg'],
      radiusMax: [100, 100],
      imageType: ['result_image'],
      deeplinkType: ['result_button'],
      textType: [
        'title',
        'sub_title',
        'roulette_items',
        'result_text',
        'result_sub_text'
      ]
    },
    button: {
      btnType: ['result_button', 'start_button'],
      radiusType: ['result_button'],
      radiusMax: [32]
    },
    tracking: {
      trackingType: [
        'background',
        'start_button',
        'result_button',
        'close_button'
      ]
    }
  }
};
